// extracted by mini-css-extract-plugin
module.exports = {"video":"styles-m__video__1bEvs","header-video":"styles-m__header-video__3HZ26","breadcrumb":"styles-m__breadcrumb__1sSyV"};